import DureeMoyenneTrajetCuscoChinchero from "./indicators/DureeMoyenneTrajetCuscoChinchero";
import DureeMoyenneTrajetCuscoUrcos from "./indicators/DureeMoyenneTrajetCuscoUrcos";

const ChallengeFour = {
    idSection: "challengeFour",
    titleSection:
        "SUMP Trajectory Content.challenges.challenge4.challengeTitle",
    objectives: {
        objective1: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge4.objectives.objective1",
            indicators: {
                dureeMoyenneTrajetCuscoChinchero:
                    DureeMoyenneTrajetCuscoChinchero,
                dureeMoyenneTrajetCuscoUrcos: DureeMoyenneTrajetCuscoUrcos,
            },
        },
    },
};

export default ChallengeFour;
